import React from 'react';
import styled from 'styled-components';
import Card, { CardProps } from './Card';

interface ClickableCardProps extends CardProps {
  onClick: () => void;
}

const ClickableWrapper = styled.div`
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  height: 100%;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
`;

const ClickableCard: React.FC<ClickableCardProps> = ({ onClick, children, ...cardProps }) => {
  return (
    <ClickableWrapper onClick={onClick}>
      <Card {...cardProps}>
        {children}
      </Card>
    </ClickableWrapper>
  );
};

export default ClickableCard; 